@if (user) {
  <div class="modal-header">
    <h3 class="modal-title" id="modal-title">{{user.firstName}} {{user.lastName}}</h3>
    <button type="button" class="btn-close" aria-describedby="redigera användare" (click)="dismiss()"></button>
  </div>
}
@if (user) {
  <div class="modal-body">
    <form id="editUserForm" [formGroup]="editForm">
      @if (user.isGuest) {
        <h4>Gästanvändare</h4>
      }
      @if (user.isGuest === false) {
        <h4>Användare</h4>
      }
      <div class="row">
        <rask-input class="col-4" label="Användar-id"  formControlName="userName" [readonly]="true"></rask-input>
        <rask-input class="col-4" label="Förnamn" formControlName="firstName" [readonly]="true"></rask-input>
        <rask-input class="col-4" label="Efternamn" formControlName="lastName" [readonly]="true"></rask-input>
      </div>
      <div class="row">
        <rask-input class="col-4" label="E-post" formControlName="email" [readonly]="true"></rask-input>
        <rask-input class="col-4" label="Mobiltelefon" formControlName="phoneNumber" [readonly]="true"></rask-input>
        <rask-input class="col-2" label="Distriktskod" formControlName="distriktskod"></rask-input>
      </div>
      <rask-tabs parameterName="section" class="parent">
        <rask-tab label="Grupper" routeId="grupper">
          <h4 header class="pt-3">Grupper</h4>
          @if (user) {
            <div class="row">
              @for (role of user.roles; track role) {
                <rask-checkbox
                  class="col-4 low"
                  [text]="role.name"
                  [raskDisabledControl]="!isUppdateraRaskEntraGrupperAllowed()"
                  [formControlName]="dedotify(role.name)"></rask-checkbox>
              }
            </div>
          }
        </rask-tab>
        <rask-tab label="Features" routeId="features">
          <h4 header class="pt-3">Features</h4>
          @if (user) {
            <div class="row">
              @for (feature of user.featureSettings; track feature) {
                <rask-checkbox
                  class="col-4 low"
                  [text]="feature.name"
                [formControlName]="dedotify(feature.name)"></rask-checkbox>
              }
            </div>
          }
        </rask-tab>
      </rask-tabs>
    </form>
  </div>
}

@if (user) {
  <div class="modal-footer">
    <rask-save-button form="editUserForm" (click)="save()" [disabled]="!editForm.dirty || !editForm.valid"></rask-save-button>
    <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus><span>Avbryt</span>
  </rask-button>
</div>
}
